var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        alignContent: 'center',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
        alignContent: 'center',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 4, width: 18 },
      ]}},[(_vm.cms.heading)?_c('a-heading',{class:`${_vm.name}__header`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),_c('div',{class:`${_vm.name}__collection`},_vm._l((_vm.cms.collection),function(item,index){return _c('div',{key:index,class:[`${_vm.name}__item`]},[((item.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image`,attrs:{"src":item.image.filename,"alt":item.image.alt,"layout":_vm.layout}}):_vm._e(),_vm._v(" "),_c('a-heading',{class:`${_vm.name}__content`,attrs:{"cms":item,"html-tag":"h4"}})],1)}),0)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }